__webpack_require__.p = "/resources/mc-crop/";